import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('admin_token'));
  const [role, setRole] = useState(localStorage.getItem('admin_role') || 'content');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyToken = async () => {
      if (token) {
        try {
          const response = await axios.get(`${API_URL}/api/admin/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setAdmin(response.data);
          setRole(response.data.role || 'admin');
          localStorage.setItem('admin_role', response.data.role || 'admin');
        } catch (error) {
          localStorage.removeItem('admin_token');
          localStorage.removeItem('admin_role');
          setToken(null);
          setRole('content');
          setAdmin(null);
        }
      }
      setLoading(false);
    };
    verifyToken();
  }, [token]);

  const login = async (username, password) => {
    const response = await axios.post(`${API_URL}/api/admin/login`, {
      username,
      password
    });
    const { access_token, admin: adminData, role: userRole, full_name } = response.data;
    localStorage.setItem('admin_token', access_token);
    localStorage.setItem('admin_role', userRole || 'admin');
    setToken(access_token);
    setRole(userRole || 'admin');
    setAdmin({
      ...adminData,
      role: userRole || 'admin',
      full_name: full_name
    });
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_role');
    setToken(null);
    setRole('content');
    setAdmin(null);
  };

  const value = {
    admin,
    token,
    role,
    loading,
    login,
    logout,
    isAuthenticated: !!admin
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
